export default {
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_AUTH_MODAL_STATUS(state, payload) {
    state.openAuthModal = payload
  },
  SET_SUCCESS_REGISTRATION_STATUS(state, payload) {
    state.openSuccessRegistration = payload
  },
  SET_WAIT_TRANSACTION(state, payload) {
    state.openWaitTransaction = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js